import { IOfferHandler } from '../../types';
import { Offer } from '../../../../services/exports/Interfaces';
import { CompleteBasketItem } from '../../../../providers/BasketProvider';
import { useTranslation } from 'react-i18next';
import useAppMethods from '../../../../hooks/utility/useAppMethods';

const useAmountOffByProducts: IOfferHandler = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Features:Offers:OfferBadge' });
  const { formatCurrency } = useAppMethods();
  const isEligible = (offer: Offer, items: CompleteBasketItem[]) =>
    items.some((item) => offer.details.products.includes(item.entry.id));
  const isEligibleItem = (offer: Offer, item: CompleteBasketItem) => offer.details.products.includes(item.entry.id);
  const getProfit = (offer: Offer, items: CompleteBasketItem[]) =>
    items
      .filter((item) => isEligibleItem(offer, item))
      .reduce((acc, item) => {
        const profit = item.quantity * offer.details.amount;

        if (profit > item.actual_price) {
          return acc + item.actual_price;
        }

        return acc + item.quantity * offer.details.amount;
      }, 0);
  const apply =
    (offer: Offer) =>
    (item: CompleteBasketItem): CompleteBasketItem => {
      if (!item.actual_price) {
        return item;
      }

      if (!isEligibleItem(offer, item)) {
        return item;
      }

      const actualPrice = Math.max(item.actual_price - offer.details.amount * item.quantity, 0);

      return {
        ...item,
        badges: [...item.badges, t(offer.kind, { amount: formatCurrency(offer.details.amount) })],
        actual_price: actualPrice,
      };
    };

  return (offer, items) => ({
    profit: getProfit(offer, items),
    isEligible: isEligible(offer, items),
    isUnlocked: isEligible(offer, items),
    apply: apply(offer),
  });
};

export default useAmountOffByProducts;
